var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quokka-layout py-7 mx-auto ma-3 px-5 px-sm-16"},[(_vm.hasEventId)?_c('QuokkaEventDetailsView',{attrs:{"event-id":_vm.eventId}}):_c('QuokkaEventListView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }